import { getRequest, postRequest, putRequest } from "api/axiosClient";
import { BaseParamsRequest } from "api/request/basParams.request";
import {
  GetExtractedPackingListsRequestParams,
  CreateExtractedPackingListJobRequestPayload,
} from "api/request/documentProcessor.request";
import {
  GetExtractedPackingListTableResponseType,
  GetExtractedPackingListDetailResponseType,
} from "api/response/documentProcessor";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/document-processor`;

export const getExtractedPackingListTable = (params: BaseParamsRequest<GetExtractedPackingListsRequestParams>) =>
  getRequest<GetExtractedPackingListTableResponseType>(`${baseURL}/extracted-packing-list/`, params);

export const getExtractedPackingListDetails = (id: number) =>
  getRequest<GetExtractedPackingListDetailResponseType>(`${baseURL}/extracted-packing-list/${id}/`);

export const createExtractedPackingListJob = (payload: CreateExtractedPackingListJobRequestPayload) =>
  postRequest(`${baseURL}/extracted-packing-list/`, payload);

export const retryExtractedPackingListJob = (id: number) =>
  postRequest(`${baseURL}/extracted-packing-list/${id}/retry/`, {});

export const updateExtractedPackingListJobStatus = (id: number, payload: any) =>
  putRequest(`${baseURL}/extracted-packing-list/${id}/status/`, payload);
